import ButtonComponent from "../../../components/common/button/Button";
import { DateComparator } from "../../../components/common/DateComparator";

export const OutBoundTableHeaders = (handleOpenOutboundModal, handleOpenNotAllowed, handleOpenCreateTicket) => {
    return [
        { field: "runOutputSeqId", headerName: "ID", width: 100 },
        { field: "supplierId", headerName: "Supplier" },
        {
            field: "materialId", headerName: "Material", cellRenderer: (response) => {
                return (
                    <span><a href={`${process.env.REACT_APP_SAP_FIORI_MATERIAL_MASTER_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#Material-display?Material=${response?.value}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
                )
            }
        },
        { field: "plant", headerName: "Plant" },
        { field: "purchasingDocType", headerName: "Purchasing Document Type" },
        { field: "shipFrom", headerName: "Incoterm Location" },
        { field: "shipTo", headerName: "Ship To City" },
        { field: "ltVariations", headerName: "Lead Time Variations" },
        { field: "finalLt", headerName: "Recommended LT to be Updated in S/4",width: 250 },
        { field: "finalApprovedBy", headerName: "Final Approved by" },
        {
            field: "createdAt", headerName: "Approved Timestamp",
            comparator: DateComparator,
            // filter: 'agDateColumnFilter',
        },
        { field: "status", headerName: "Status" },
        {
            field: "modifiedAt", headerName: "Status Updated at",
            comparator: DateComparator,
            // filter: 'agDateColumnFilter',
        },
        { field: "s4NoOfAttempts", headerName: "S/4 No of Attempts" },
        { field: "mdgNoOfAttempts", headerName: "MDG No of Attempts" },
        {
            field: "s4ErrorMessage", headerName: "S/4 Error Description", width: 300,
            autoHeight: true,
            cellStyle: { whiteSpace: "normal", lineHeight: 1.5 },
        },
        {
            field: "mdgErrorMessage", headerName: "MDG Error Description", width: 300,
            autoHeight: true,
            cellStyle: { whiteSpace: "normal", lineHeight: 1.5 },
        },
        {
            field: "contractUpdateStatus", headerName: "Contract Update",
            cellRenderer: (response) => {
                return (
                    (response?.value === "NA" || response?.value === null || response?.value === undefined || response?.value === "" || response?.value === "-") ?
                        <div>
                            {" "}
                            <span>{response.value}</span>
                        </div>
                        :
                        <div>
                            {" "}
                            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleOpenOutboundModal(response.data, "Contracts")} >{response.value}</span>
                        </div>
                )
            }
        },
        {
            field: "pirUpdateStatus", headerName: "PIR Update",
            cellRenderer: (response) => {
                return (
                    (response?.value === "NA" || response?.value === null || response?.value === undefined || response?.value === "" || response?.value === "-") ?
                        <div>
                            {" "}
                            <span>{response.value}</span>
                        </div>
                        :
                        <div>
                            {" "}
                            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleOpenOutboundModal(response.data, "PIR")} >{response.value}</span>
                        </div>
                )
            }
        },
        { field: "mmUpdateStatus", headerName: "Material Master Update" },
        {
            field: "mdgTicketNumber", headerName: "MDG Support Ticket", cellRenderer: (response) => {
                return (
                    response?.data?.mdgTicketId ?
                        <span><a href={`${process.env.REACT_APP_MS_DYNAMICS_TICKET_BASE_URL}&id=${response?.data?.mdgTicketId}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
                        :
                        <span>{response?.value || "-"}</span>
                )
            }
        },
        {
            field: "s4TicketNumber", headerName: "S/4 Support Ticket", cellRenderer: (response) => {
                return (
                    response?.data?.s4TicketId && response?.data?.s4TicketNumber !== "Not Allowed" ?
                        <span><a href={`${process.env.REACT_APP_MS_DYNAMICS_TICKET_BASE_URL}&id=${response?.data?.s4TicketId}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
                        :
                        response?.data?.s4TicketId===null && response?.data?.s4TicketNumber === "Not Allowed" ?
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleOpenNotAllowed(response.data)} >{response?.value}</span>
                        :
                        <span>{response?.value || "-"}</span>
                )
            }
        },
        // {
        //     field: "Create Ticket",
        //     width: 145,
        //     cellRenderer: (response) => (
        //         <div className="btn-wrapper">
        //             <ButtonComponent type="secondary" label="Create Ticket" fontSize="12px" disabled={response?.data?.isDisableTicket} onClick={() => handleOpenCreateTicket(response.data)} />
        //         </div>
        //     ),
        //     pinned: "right",
        //     lockPinned: true,
        // },
    ]
}

